/**
 * Reading-line scroll spy for policy pages.
 * The last chapter whose top has passed 32% of the viewport is current.
 * With no directory, this does nothing.
 */
(function () {
  let frame = 0;
  let lastActive = '';

  function aside() {
    return document.querySelector('.policy-layout aside');
  }

  function update() {
    frame = 0;
    const nav = aside();
    if (!nav) return;

    const links = Array.from(nav.querySelectorAll("a[href^='#']"));
    const contentSections = links
      .map(function (link) {
        const id = (link.getAttribute('href') || '').replace(/^#/, '');
        return id ? document.getElementById(id) : null;
      })
      .filter(Boolean);

    if (contentSections.length === 0) return;

    nav.classList.add('scrollspy-ready');

    const readingLine = window.innerHeight * 0.32;
    let active = contentSections[0].id;
    for (let i = 0; i < contentSections.length; i += 1) {
      const section = contentSections[i];
      if (section.getBoundingClientRect().top <= readingLine) active = section.id;
      else break;
    }

    let activeLink = null;
    links.forEach(function (link) {
      const id = (link.getAttribute('href') || '').replace(/^#/, '');
      const selected = id === active;
      link.classList.toggle('is-active', selected);
      if (selected) {
        link.setAttribute('aria-current', 'location');
        activeLink = link;
      } else {
        link.removeAttribute('aria-current');
      }
    });

    if (window.innerWidth <= 760 && activeLink && active !== lastActive) {
      const left = activeLink.offsetLeft - (nav.clientWidth - activeLink.offsetWidth) / 2;
      nav.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
    lastActive = active;
  }

  function onScroll() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  if (!window.__aaPolicyScrollspy) {
    window.__aaPolicyScrollspy = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('shopify:section:load', function () {
      lastActive = '';
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
